<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>カレンダー情報の編集</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex md3>
              <h3>{{value.year}}年{{value.month}}月{{value.date}}日</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md1>
              <v-select :items="options" v-model="value.is_holiday"></v-select>
            </v-flex>
            <v-flex md4>
              <v-text-field v-model="value.holiday_name" label="何の日"  ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">キャンセル</v-btn>
        <v-btn v-if="action == 'update'" @click="updateItem">更新</v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'value', 'action'
  ],
  data() {
    return {
      options: [{ text: "平日", value: false }, { text: "休日", value: true }]
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    close() {
      this.$emit('closeDialog')
    },
    addItem() {
      this.$emit('createItem')
    },
    updateItem() {
      this.$emit('updateItem')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>